import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <>
      <Helmet>
        <title>Müügitingimused | Tõuks.ee</title>
        <meta name="description" content="Tõuks.ee müügitingimused. Tutvuge ostmise, maksmise, kohaletoimetamise ja tagastamise tingimustega." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://xn--tuks-0qa.ee/muugitingimused" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Kodu", "item": "https://xn--tuks-0qa.ee/" },
            { "@type": "ListItem", "position": 2, "name": "Müügitingimused", "item": "https://xn--tuks-0qa.ee/muugitingimused" }
          ]
        })}</script>
      </Helmet>

      <div className="container mx-auto py-12 px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-6">Müügitingimused</h1>

          <p className="mb-8 text-gray-600 leading-relaxed">
            Käesolevad tingimused reguleerivad kaupade müüki Kvantis OÜ (registrikood 17190909, KMKR EE102837029), aadressiga Suislepa tn 2, Jõgeva, Eesti (edaspidi „Müüja", „meie" või „me") poolt hallatavas veebipoes <strong>tõuks.ee</strong>.
          </p>

          {/* 1. Hinnad */}
          <h2 className="text-2xl font-bold mt-10 mb-4">1. Hinnad</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Kõik veebipoes kuvatavad hinnad on eurodes (€) ja sisaldavad Eesti käibemaksu (24%). Tarnekulud kuvatakse enne tellimuse kinnitamist.
          </p>
          <p className="text-gray-600 leading-relaxed mb-6">
            Jätame endale õiguse hindu igal ajal muuta. Hinnamuudatus ei mõjuta tellimusi, mis on esitatud enne muudatuse jõustumist. Sooduskoodid kehtivad täishinnaga toodetele, kui pole märgitud teisiti.
          </p>

          {/* 2. Tellimine ja makseviisid */}
          <h2 className="text-2xl font-bold mt-10 mb-4">2. Tellimine ja makseviisid</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Tellimuse saab esitada ilma registreerumiseta. Klient valib soovitud tooted, lisab need ostukorvi ning sisestab kassas tarne- ja makseandmed.
          </p>
          <p className="text-gray-600 leading-relaxed mb-4">
            Makseid vahendab turvaliselt <strong>ESTO AS</strong>. Kõik tehingud toimuvad turvalises keskkonnas. Müüjal ei ole ligipääsu kliendi pangakaardi ega pangaandmetele.
          </p>
          <p className="text-gray-600 mb-2 font-medium">Toetatud makseviisid:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1 text-gray-600">
            <li>Pangalingid: Swedbank, SEB, LHV, Coop Pank, Citadele, Luminor, Revolut</li>
            <li>ESTO järelmaks kuni 60 kuuks (0€ lepingutasu)</li>
            <li>Arve alusel maksmine</li>
          </ul>
          <p className="text-gray-600 leading-relaxed mb-6">
            Ostuleping loetakse sõlmituks, kui makse on edukalt laekunud. Pärast makse kinnitamist saadetakse kliendile automaatne tellimuskinnitus e-posti teel. Kui toode on ajutiselt otsas või ei ole tarnitav, teavitame klienti esimesel võimalusel ja tagastame makstud summa 14 päeva jooksul.
          </p>

          {/* 3. Tarne */}
          <h2 className="text-2xl font-bold mt-10 mb-4">3. Tarne</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Saadame tellimusi üle Eesti. Meie tarnepartnerid on <strong>DPD</strong>, <strong>Omniva</strong> ja <strong>SmartPost</strong>.
          </p>
          <p className="text-gray-600 leading-relaxed mb-4">
            Tellimuste töötlemise aeg: <strong>1–14 tööpäeva</strong> pärast makse laekumist (laos olevad tooted saadame 1–2 tööpäevaga, tellitavad tooted 5–14 tööpäevaga).
          </p>
          <p className="text-gray-600 mb-2 font-medium">Tarneajad pärast väljasaatmist:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1 text-gray-600">
            <li>Eesti (pakiautomaat) — 1–3 tööpäeva</li>
          </ul>
          <p className="text-gray-600 leading-relaxed mb-4">
            Kõikidele tellimustele lisatakse jälgimislink, mis saadetakse kliendile e-posti teel pärast väljasaatmist. Tarnekulud on <strong>tasuta</strong>.
          </p>
          <p className="text-gray-600 leading-relaxed mb-6">
            Müüja ei vastuta viivituste eest, mis on põhjustatud valedest aadressidest, pakiautomaadi täitumisest või muudest vääramatu jõu asjaoludest. Palume kontrollida saadud kaupa koheselt ning teavitada võimalikest kahjustustest e-posti teel <a href="mailto:ametliktouks@gmail.com" className="text-[#4FC1E9] hover:underline">ametliktouks@gmail.com</a> 48 tunni jooksul.
          </p>

          {/* 4. Taganemisõigus ja tagastused */}
          <h2 className="text-2xl font-bold mt-10 mb-4">4. Taganemisõigus ja tagastused</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            EL ja Eesti seaduste järgi on tarbijal õigus tellimusest taganeda <strong>14 päeva jooksul</strong> alates kauba kättesaamisest, ilma põhjust esitamata (vastavalt Võlaõigusseaduse § 56-le).
          </p>
          <p className="text-gray-600 leading-relaxed mb-4">
            Taganemisõiguse kasutamiseks palume võtta meiega ühendust 14 päeva jooksul aadressil <a href="mailto:ametliktouks@gmail.com" className="text-[#4FC1E9] hover:underline">ametliktouks@gmail.com</a>, lisades tellimuse numbri ja taganemise põhjuse. Tagastatav kaup peab olema:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-1 text-gray-600">
            <li>kasutamata ja originaalpakendis</li>
            <li>tagastatud 14 päeva jooksul alates taganemisteatest</li>
          </ul>
          <p className="text-gray-600 leading-relaxed mb-4">
            Raha tagastame 14 päeva jooksul pärast kauba kättesaamist ja seisukorra kontrollimist. Defektse toote tagastamiskulud katame meie. Muudel juhtudel kannab tagastamise postikulu klient.
          </p>
          <p className="text-gray-600 leading-relaxed mb-6">
            Kui tagastatav toode on kasutatud, kahjustatud või ei ole originaalpakendis, on Müüjal õigus keelduda tagastamisest või teha osaline tagastus. Müüja dokumenteerib toote seisukorra kauba tagasisaamisel.
          </p>

          {/* 5. Garantii ja vastutus */}
          <h2 className="text-2xl font-bold mt-10 mb-4">5. Garantii ja vastutus</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Kõigil toodetel on <strong>kaheaastane garantiiperiood</strong> tootmisdefektide osas vastavalt EL tarbijakaitse nõuetele. Kvantis OÜ vastutab müüdud kauba lepingutingimustele mittevastavuse eest, mis ilmnes enne kauba üleandmist ning avaldub kuni kahe aasta jooksul alates üleandmisest.
          </p>
          <p className="text-gray-600 mb-2 font-medium">Garantii ei kata:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1 text-gray-600">
            <li>tavalist kulumist (rattad, griptape, klamber jms)</li>
            <li>ebaõigest kasutamisest, õnnetustest või hooletusest tingitud kahjustusi</li>
            <li>kasutaja poolt modifitseeritud või parandatud tooteid</li>
          </ul>
          <p className="text-gray-600 leading-relaxed mb-4">
            Klient kohustub teavitama kauba mittevastavusest hiljemalt kahe kuu jooksul selle avastamisest. Pretensioonid palume esitada e-posti teel: <a href="mailto:ametliktouks@gmail.com" className="text-[#4FC1E9] hover:underline">ametliktouks@gmail.com</a>. Pretensioonile vastatakse 15 tööpäeva jooksul. Asendame, parandame või tagastame ostusumma vastavalt olukorrale.
          </p>

          {/* 6. Makse ja turvalisus */}
          <h2 className="text-2xl font-bold mt-10 mb-4">6. Makse ja turvalisus</h2>
          <p className="text-gray-600 leading-relaxed mb-6">
            Makseid töötleb <strong>ESTO AS</strong>. Kõik tehingud on krüpteeritud ja töödeldakse vastavalt EL-i andmekaitsenõuetele. Müüja ei salvesta kliendi pangakaardi andmeid.
          </p>

          {/* 7. Vastutuse piiramine */}
          <h2 className="text-2xl font-bold mt-10 mb-4">7. Vastutuse piiramine</h2>
          <p className="text-gray-600 leading-relaxed mb-6">
            Kvantis OÜ ei vastuta kahjude või viivituste eest, mis on põhjustatud meist sõltumatutest asjaoludest, sealhulgas vääramatu jõu olukorrad, kullerite hilinemised või kolmandate osapoolte teenusekatkestused. Meie vastutus ühe tellimuse kohta ei ületa tellimuse eest makstud summat.
          </p>

          {/* 8. Isikuandmete töötlemine */}
          <h2 className="text-2xl font-bold mt-10 mb-4">8. Isikuandmete töötlemine</h2>
          <p className="text-gray-600 leading-relaxed mb-6">
            Tellimisprotsessi käigus kogutud isikuandmeid töödeldakse vastavalt meie{' '}
            <Link to="/privaatsustingimused" className="text-[#4FC1E9] hover:underline">privaatsuspoliitikale</Link>.
            Kogume ainult andmeid, mis on vajalikud tellimuse täitmiseks ja kohaletoimetamiseks, ning ei jaga neid kolmandatele osapooltele, välja arvatud makse- ja tarnepartnerid (ESTO AS, DPD, Omniva, SmartPost).
          </p>

          {/* 9. Nõustumine tingimustega */}
          <h2 className="text-2xl font-bold mt-10 mb-4">9. Nõustumine tingimustega</h2>
          <p className="text-gray-600 leading-relaxed mb-6">
            Tellimuse esitamisega kinnitab Klient, et on tutvunud käesolevate müügitingimustega ning privaatsuspoliitikaga ja nõustub nendega.
          </p>

          {/* 10. Kohaldatav õigus ja vaidluste lahendamine */}
          <h2 className="text-2xl font-bold mt-10 mb-4">10. Kohaldatav õigus ja vaidluste lahendamine</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Käesolevatele tingimustele ja neist tulenevatele vaidlustele kohaldatakse Eesti Vabariigi õigust. Vaidluste korral palume kõigepealt pöörduda meie klienditoe poole.
          </p>
          <p className="text-gray-600 leading-relaxed mb-6">
            Kui kokkulepet ei saavutata, võib tarbija esitada kaebuse{' '}
            <a href="https://komisjon.ee" target="_blank" rel="noopener noreferrer" className="text-[#4FC1E9] hover:underline">Tarbijavaidluste komisjonile</a>
            {' '}(komisjon.ee) või Euroopa Liidu veebipõhise vaidluste lahendamise platvormi kaudu:{' '}
            <a href="https://ec.europa.eu/odr" target="_blank" rel="noopener noreferrer" className="text-[#4FC1E9] hover:underline">ec.europa.eu/odr</a>.
          </p>

          {/* 11. Kontaktandmed */}
          <h2 className="text-2xl font-bold mt-10 mb-4">11. Kontaktandmed</h2>
          <div className="bg-gray-50 rounded-xl p-6 space-y-2 text-gray-600">
            <p><span className="font-medium">Ettevõte:</span> Kvantis OÜ</p>
            <p><span className="font-medium">Reg. kood:</span> 17190909</p>
            <p><span className="font-medium">KMKR:</span> EE102837029</p>
            <p><span className="font-medium">Aadress:</span> Suislepa tn 2, Jõgeva, Eesti</p>
            <p>
              <span className="font-medium">E-post:</span>{' '}
              <a href="mailto:ametliktouks@gmail.com" className="text-[#4FC1E9] hover:underline">ametliktouks@gmail.com</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
